'use es6';

let _ = t => t,
  _t;
import styled from 'styled-components';
import spiderweb from 'bender-url!../../../img/spiderweb-corner.png';
import { TabletAndBelow } from '../themes/mixins';
import { jsx as _jsx } from "react/jsx-runtime";
const UpperLeft = styled.div.withConfig({
  displayName: "SpiderWebs__UpperLeft"
})(["transform:rotate(270deg);position:absolute;height:200px;width:auto;left:-20px;opacity:0.2;z-index:100;"]);
const UpperRight = styled.div.withConfig({
  displayName: "SpiderWebs__UpperRight"
})(["position:absolute;height:200px;width:auto;right:0;top:-10px;opacity:0.2;", ""], TabletAndBelow(_t || (_t = _`
    display: none;
  `)));
export const SpiderWebLeft = () => /*#__PURE__*/_jsx(UpperLeft, {
  children: /*#__PURE__*/_jsx("img", {
    src: spiderweb
  })
});
export const SpiderWebRight = () => /*#__PURE__*/_jsx(UpperRight, {
  children: /*#__PURE__*/_jsx("img", {
    src: spiderweb
  })
});